import { makeAutoObservable } from 'mobx';
import EmailTemplate from 'main/stores/email_templates/EmailTemplate';

class EmailTemplateState { 
  store;
  history;

  emailTemplate = new EmailTemplate();
  emailTemplates = [];
  addEmailTemplateModalOpen = false;
  errors = {};

  constructor(store, history) {
    makeAutoObservable(this, {
      store: false,
      history: false
    });

    this.store = store;
    this.history = history;
  }

  async load() {
    await this.refreshEmailTemplates();
  }

  async refreshEmailTemplates() {
    this.emailTemplates = await this.store.loadEmailTemplates();
  }

  openAddEmailTemplateModal() {
    this.addEmailTemplateModalOpen = true;
  }

  closeAddEmailTemplateModal() {
    this.addEmailTemplateModalOpen = false;
  }

  goToEmailTemplateForm(emailTemplate) {
    this.history.push(`email-templates/${emailTemplate.id}`);
  }

  async createEmailTemplate() {
    const {model, errors} = await this.store.postEmailTemplate(this.emailTemplate);
    this.errors = errors;

    if (model) {
      this.goToEmailTemplateForm(model);
    }
  }

  async removeEmailTemplate(template) {
    await this.store.destroy(template);
    await this.refreshEmailTemplates();
  }
}

export default EmailTemplateState;
